/**
 * Mexican states slug mapping
 * Keys are slug format (hyphenated) as they appear in location URLs
 */
export const MX_STATE_ABBREVIATIONS: Record<string, string> = {
    Aguascalientes: "AGS",
    "Baja-California": "BC",
    "Baja-California-Sur": "BCS",
    Campeche: "CAM",
    Chiapas: "CHIS",
    Chihuahua: "CHIH",
    "Ciudad-de-Mexico": "CDMX",
    Coahuila: "COAH",
    Colima: "COL",
    Durango: "DGO",
    Guanajuato: "GTO",
    Guerrero: "GRO",
    Hidalgo: "HGO",
    Jalisco: "JAL",
    "Estado-de-Mexico": "MEX",
    Michoacan: "MICH",
    Morelos: "MOR",
    Nayarit: "NAY",
    "Nuevo-Leon": "NL",
    Oaxaca: "OAX",
    Puebla: "PUE",
    Queretaro: "QRO",
    "Quintana-Roo": "QROO",
    "San-Luis-Potosi": "SLP",
    Sinaloa: "SIN",
    Sonora: "SON",
    Tabasco: "TAB",
    Tamaulipas: "TAMPS",
    Tlaxcala: "TLAX",
    Veracruz: "VER",
    Yucatan: "YUC",
    Zacatecas: "ZAC",
};
